module.exports = __webpack_public_path__ + "static/img/dummy-400x300-Seagull-plain.63d69a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dummy-400x300-Seagull-plain.jpg
// module id = W4Jy
// module chunks = 0